var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wraper"},[_c('Header'),_vm._v(" "),_c('section',{staticClass:"content-area"},[_c('MainMenu'),_vm._v(" "),_c('div',[_vm._v("DogovorsServices OM")])],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }